import { SVGSprite } from "@/components/Atoms";

import { classNameGenerator } from "@/utils";

import styles from "./ConditionItem.module.scss";
import Typography from "@/foundation/Typography/V2";

interface ConditionItemProps {
  icon: string;
  title: string;
}

const ConditionItem: React.FC<ConditionItemProps> = ({ icon, title }) => {
  const cls = classNameGenerator(styles);

  return (
    <div className={cls("conditionItem")}>
      <SVGSprite icon={icon} className={cls("icon")} />
      <Typography
        variant="heading6"
        className={cls("title")}
        dangerouslySetInnerHTML={{ __html: title }}
      />
    </div>
  );
};

export default ConditionItem;
